import $store from "@/store";
import {GETTER_MOBILENUMBER} from "@/store/types";

import {
  getNextOkDate,
} from "@/utils/dates";
import {PageTypes} from "@/reference";

export const generateGetLabTestCouponPayload = (prescriptionUploadId, patient) => {
  return {
    files: [
      prescriptionUploadId,
    ],
    lastname: patient.lastname,
    firstname: patient.firstname,
    mobilenumber: $store.getters[GETTER_MOBILENUMBER],
    partnercode: 'hipres',
    timeOfAppointment: getNextOkDate(),
    address: {
      city: '',
      street: '',
      roomnumber: '',
    },
  };
};

export const transformReceivedLabResult = (labResult, doctorPatientPartner) => {
  labResult.doctorname = doctorPatientPartner.doctor._fullName;
  labResult.patientname = doctorPatientPartner.patient.name;
  labResult.pagetype = PageTypes.__labresults;
  return labResult;
};
